import React from 'react';
import { motion } from 'framer-motion';
const stats = [{
  value: '200+',
  label: 'Patrones Exactos'
}, {
  value: '6',
  label: 'eBooks Técnicos'
}, {
  value: '100%',
  label: 'Organizado en Drive'
}, {
  value: '∞',
  label: 'Actualizaciones Futuras'
}];
export function StatsBar() {
  return <section className="bg-leather-dark py-12 px-4 sm:px-6 lg:px-8" data-id="element-177">
      <div className="max-w-7xl mx-auto" data-id="element-178">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center" data-id="element-179">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex flex-col items-center" data-id="element-180">
              <span className="font-heading text-4xl md:text-5xl font-bold text-gold mb-2" data-id="element-181">
                {stat.value}
              </span>
              <span className="text-cream text-sm md:text-base font-medium uppercase tracking-wider" data-id="element-182">
                {stat.label}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}